<template>
  <div class="eval-preview">
    <a-page-header v-if="showHeader" class="page-header" @back="back">
      <div slot="title" @click="back">
        返回
        <span style="color: #297ede">心理测评</span>
      </div>
    </a-page-header>
    <div class="content">
      <div class="title">{{ previewEvalData.name }}</div>
      <div class="remark-area">
        <div>简介：</div>
        <div class="remark">
          {{ previewEvalData.remark }}
        </div>
      </div>
      <div class="topic-desc">测评内容</div>
      <div v-for="(item, index) in dataSource" :key="index">
        <div
          :class="{ topic: true, 'topic-active': remindStatus && !selectMode[index] }"
          ref="topicRef"
        >
          <!--          <span>{{ index + 1 }}、</span>-->
          <span v-if="remindStatus && !selectMode[index]">（未填）</span>
          <span>{{ item.name }}</span>
        </div>
        <div class="select-area">
          <a-radio-group
            v-for="(optItem, optIndex) in item.topicArr"
            :key="optIndex"
            :disabled="radioDisabled"
            v-model="selectMode[index]"
            @change="changeRadioGroup"
          >
            <a-radio :value="`${item.id},${optItem.id},${optItem.score}`">
              <span style="color: rgba(0, 0, 0, 0.65)">{{ optItem.name }}</span>
            </a-radio>
          </a-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from '@api/manage'

export default {
  name: 'EvalPreview',
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
    previewEvalData: {
      type: Object,
      default: () => ({
        // name: '中学生焦虑量表',
        // remark: '备注信息',
        // id: '5dc93950d41e48c5bae12dd74b41d618',
      }),
    },
    activeKey: {
      type: [String, Number],
      default: 0,
    },
    topicObj: {
      type: Object,
      default: () => ({}),
    },
    remindStatus: {
      // 预览时为false，可填写为true，主要用于控制是否显示未填选项高亮
      type: Boolean,
      default: false,
    },
    radioDisabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dataSource: [],
      selectMode: [],
      topicStoreArr: [],
      // 题目加载状态：loading-加载中 empty-暂无可答题目 error-加载失败 ready-加载完成
      topicStatus: '',
    }
  },
  components: {},
  created() {
    this.getEvalTopic()
  },
  watch: {
    topicObj: {
      handler() {
        this.topicStoreArr = this.topicObj?.[this.activeKey] || []
      },
      deep: true,
      immediate: true,
    },
    activeKey: {
      handler() {
        this.topicStoreArr = this.topicObj?.[this.activeKey] || []
        this.getEvalTopic()
      },
    },
  },
  methods: {
    setTopicStatus(status) {
      this.topicStatus = status
      this.$emit('topicStatusChange', status)
    },
    getEvalTopic() {
      // 当前测评无 id（还没拿到测评列表）时按无题处理，保证按钮处于禁用态
      if (!this.previewEvalData.id) {
        this.setTopicStatus('empty')
        return
      }
      this.setTopicStatus('loading')
      getAction('/schoolEvaluationQuestion/getByEvaluationId', {
        evaluationId: this.previewEvalData.id,
      })
        .then((res) => {
          if (res.success) {
            if (res.result?.length) {
              this.dataSource = res.result?.map((item) => ({
                ...item,
                topicArr: item.schoolEvaluationAnswerOptionsList,
              }))
              // console.log('题目数据：', this.dataSource)
              this.selectMode = this.topicStoreArr
       
              this.setTopicStatus('ready')
            } else {
              // 接口成功但没有题目数据
              this.setTopicStatus('empty')
            }
          } else {
            // 接口返回失败
            this.setTopicStatus('error')
          }
        })
        .catch(() => {
          // 网络/接口异常
          this.setTopicStatus('error')
        })
    },
    back() {
      this.$emit('back')
    },
    changeRadioGroup() {
      console.log('监听变化：', this.selectMode)
      this.$emit('changeRadioGroup', {
        [this.activeKey]: this.selectMode,
      })
    },
  },
}
</script>
<style scoped lang="less">
.page-header {
  padding-left: 0;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  /deep/ .ant-page-header-heading-title {
    font-size: 14px;
  }
}
.eval-preview {
  height: calc(100% - 30px);
  min-height: 70vh;
  border-bottom: 1px solid #eee;
}
.topic {
  font-size: 15px;
  line-height: 20px;
}
.topic-active {
  color: #fff;
  // 背景色渐变，同时设置角度
  background: linear-gradient(to right, #f76668, #fc9193);
  padding: 10px;
  border-radius: 8px;
}
.title {
  font-size: 18px;
  font-weight: bold;
  color: #717378;
}
.topic-desc {
  margin: 20px 0;
  font-size: 16px;
  font-weight: 600;
  color: #717378;
}
.select-area {
  margin: 20px;
  margin-bottom: 30px;
}
.content {
  height: 100%;
  padding: 20px;
  //background-color: #f2f6ff;
  overflow-y: auto;
}
.remark-area {
  max-width: 100%;
  padding: 15px 0;
  margin: 15px 0;
  border-top: 1px solid #ebecef;
  border-bottom: 1px solid #ebecef;
  font-size: 15px;
  .remark {
    max-width: 100%;
    color: #b4bdd3;
  }
}
</style>
